<script lang="ts">
    import type {CssSize} from 'shared/ui-widgets/types';
    import type {UIcons, UIconVariant} from './types';
    import {exists} from 'shared/utils/custom-utils';
    import UIcon from './UIcon.svelte';

    export let icon: UIcons | null = null;
    export let iconVariant: UIconVariant = 'bold';
    export let trailingIcon: UIcons | null = null;
    export let trailingIconVariant: UIconVariant = 'bold';
    export let iconColor = 'inherit';
    export let orientation: 'vertical' | 'horizontal' = 'horizontal';
    export let align: 'start' | 'center' | 'end' = 'center';
    export let textAlign: 'start' | 'center' | 'end' = 'center';
    export let justify: 'start' | 'center' | 'end' = 'center';
    export let iconLineHeight = 'inherit';
    export let gap: CssSize = '1ch';
    export let fillAvailableSpace = false;
    export let additionalClasses = '';
</script>

<div class="iconed-content {orientation} {additionalClasses}"
     class:fill-available-space={fillAvailableSpace}
     style:--align={fillAvailableSpace ? 'center' : align}
     style:--justify={fillAvailableSpace ? 'center' : justify}
     style:--textAlign={textAlign}
     style:--gap={gap}>

    {#if $$slots.icon}
        <slot name="icon" color={iconColor} lineHeight={iconLineHeight}/>
    {:else if exists(icon)}
        <UIcon {icon} variant={iconVariant} color={iconColor} lineHeight={iconLineHeight}/>
    {/if}

    {#if $$slots.default}
        <slot/>
    {/if}

    {#if exists(trailingIcon)}
        <UIcon icon={trailingIcon} variant={trailingIconVariant} color={iconColor} lineHeight={iconLineHeight}/>
    {/if}
</div>

<style lang="less">
    .iconed-content {
        display: flex;
        gap: var(--gap);
        align-items: var(--align);
        justify-content: var(--justify);
        text-align: var(--textAlign);

        &.fill-available-space {
            width: 100%;
            height: 100%;
        }

        &.vertical {
            flex-direction: column;
        }
    }
</style>